import {
  GETClockingActionResponse,
  GETClockingActionYearListResponse,
  GETClockingActionsResponse,
  GETProductivityReportResponse,
  GETWorkOrderClockingActionsResponse,
  IClockingActionData,
  POSTActionClockInBody,
  POSTActionClockInResponse,
  PUTActionClockOutBody,
  PUTActionClockOutResponse
} from '@cbgms/api/modules/clocking-actions'
import { IPaginatedRequest, IProductivityReportRequest } from '@cbgms/api/request'
import * as requests from '@cbgms/api/modules/clocking-actions/requests'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const listClockingActions = (params: IPaginatedRequest) =>
  AsyncAction<GETClockingActionsResponse>({
    type: [types.LIST_CLOCKING_ACTION, types.LIST_CLOCKING_ACTION_SUCCESS, types.LIST_CLOCKING_ACTION_FAILED],
    payload: {
      api: 'gms',
      request: requests.listClockingActions(params)
    }
  })

export const currentClockingAction = () =>
  AsyncAction<GETClockingActionResponse>({
    type: [types.CURRENT_CLOCKING_ACTION, types.CURRENT_CLOCKING_ACTION_SUCCESS, types.CURRENT_CLOCKING_ACTION_FAILED],
    payload: {
      api: 'gms',
      request: requests.currentClockingAction()
    }
  })

export const currentClockingActionStateless = () => createAsyncApiAction<GETClockingActionResponse>('gms', requests.currentClockingAction())

export const clockInAction = (body: POSTActionClockInBody) =>
  AsyncAction<POSTActionClockInResponse>({
    type: [types.ACTION_CLOCK_IN, types.ACTION_CLOCK_IN_SUCCESS, types.ACTION_CLOCK_IN_FAILED],
    payload: {
      api: 'gms',
      request: requests.clockInAction(body)
    }
  })

export const clockOutAction = (body: PUTActionClockOutBody) =>
  AsyncAction<PUTActionClockOutResponse>({
    type: [types.ACTION_CLOCK_OUT, types.ACTION_CLOCK_OUT_SUCCESS, types.ACTION_CLOCK_OUT_FAILED],
    payload: {
      api: 'gms',
      request: requests.clockOutAction(body)
    }
  })

export const setClockingActions = (payload: IClockingActionData) => ({
  type: types.SET_CLOCKING_ACTIONS,
  payload
})

export const setPopoverClockingActions = (payload: IClockingActionData) => ({
  type: types.SET_POPOVER_CLOCKING_ACTIONS,
  payload
})

export const workorderClockingActions = (workorderUUID: string) =>
  AsyncAction<GETWorkOrderClockingActionsResponse>({
    type: [types.WORKORDER_CLOCKING_ACTIONS, types.WORKORDER_CLOCKING_ACTIONS_SUCCESS, types.WORKORDER_CLOCKING_ACTIONS_FAILED],
    payload: {
      api: 'gms',
      request: requests.workorderClockingActions(workorderUUID)
    }
  })

export const workorderClockingActionsStateless = (workorderUUID: string) =>
  createAsyncApiAction<GETWorkOrderClockingActionsResponse>('gms', requests.workorderClockingActions(workorderUUID))

export const getEmployeeClockingActions = (params: IPaginatedRequest) =>
  AsyncAction<GETClockingActionsResponse>({
    type: [types.EMPLOYEE_CLOCKING_ACTIONS, types.EMPLOYEE_CLOCKING_ACTIONS_SUCCESS, types.EMPLOYEE_CLOCKING_ACTIONS_FAILED],
    payload: {
      api: 'gms',
      request: requests.employeeClockingActions(params)
    }
  })

export const getClockingYearList = () =>
  AsyncAction<GETClockingActionYearListResponse>({
    type: [types.LIST_CLOCKING_ACTIONS_YEARS, types.LIST_CLOCKING_ACTIONS_YEARS_SUCCESS, types.LIST_CLOCKING_ACTIONS_YEARS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getClockingYearList()
    }
  })

export const getProductivityReportActions = (params: IProductivityReportRequest) =>
  AsyncAction<GETProductivityReportResponse>({
    type: [types.LIST_PRODUCTIVITY_REPORT, types.LIST_PRODUCTIVITY_REPORT_SUCCESS, types.LIST_PRODUCTIVITY_REPORT_FAILED],
    payload: {
      api: 'gms',
      request: requests.getProductivityReport(params)
    }
  })
